<template>
  <div v-if="items" class="gp-content">
    <table-tile-bar :view.sync="view" :refresh="refresh">
      <p class="level-item is-size-4 bar-title">Deployments</p>
      <pagination
        class="level-item"
        :next="hasNext"
        :prev="hasPrev"
        :nextClick="nextPage"
        :prevClick="prevPage"
        :page="page"
        :perPage="perPage"
        :itemCount="itemCount"
        :total="total"
        :loading="loading">
      </pagination>
      <router-link class="button add" :to="{ name: 'deployments.index.create' }">
        <i class="fas fa-plus"></i>
        Create Deployment
      </router-link>
    </table-tile-bar>
    <div class="scroll-vertical">
      <deployments-table
        v-if="view === 'table'"
        :deployments="items"
        :deleteFunc="deleteFunc"
        :sortDirection="sortDirection"
        :sortField="sortField"
        :onSort="onSort">
      </deployments-table>
      <deployments-tiles
        v-else :deployments="items"
        :deleteFunc="deleteFunc">
      </deployments-tiles>
    </div>
  </div>
</template>

<script>
import pagination from '@/mixins/pagination';
import TableTileBar from '@/components/TableTileBar.vue';
import DeploymentsTable from '@/components/deployments/DeploymentsTable.vue';
import DeploymentsTiles from '@/components/deployments/DeploymentsTiles.vue';
import Pagination from '@/components/Pagination.vue';

export default {
  name: 'Deployments',
  mixins: [pagination],
  components: {
    DeploymentsTable,
    DeploymentsTiles,
    TableTileBar,
    Pagination,
  },
  data() {
    return {
      endpoint: 'primary/listDeployments',
      sortDirection: 'DESC',
      sortField: 'created',
    };
  },
  computed: {
    view: {
      set(value) { this.$store.commit('deploymentViewState/SET_VIEW', value); },
      get() { return this.$store.state.deploymentViewState.view; },
    },
    requestVars() {
      return {
        direction: this.sortDirection,
        field: this.sortField,
      };
    },
  },
  async mounted() {
    this.refresh(null);
  },
  methods: {
    async deleteFunc(id) {
      await this.$store.dispatch('primary/deleteDeployment', { id });
      this.refresh();
    },
    onSort(field, order) {
      this.sortDirection = order.toUpperCase();
      this.sortField = field;
      this.reset();
    },
  },
};
</script>
